function time(dateObj) {
  if (dateObj) {
    const hour = dateObj.getHours() > 9 ? dateObj.getHours() : `0${dateObj.getHours()}`;
    const minute = dateObj.getMinutes() > 9 ? dateObj.getMinutes() : `0${dateObj.getMinutes()}`;

    return `${hour}:${minute}`;
  }

  return '';
}

export default time;
